import React from "react";
import { useNavigate } from "react-router-dom";

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 text-white p-6 relative">
      {/* Header Section */}
      <header className="text-center py-6">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold">
          Terms and Conditions
        </h1>
        {/* <p className="mt-2 text-sm sm:text-base opacity-80">
          Last updated: August 2025
        </p> */}
      </header>

      {/* Content Section */}
      <main className="flex-grow max-w-4xl mx-auto bg-white bg-opacity-10 rounded-2xl shadow-lg p-6 sm:p-10 overflow-y-auto">
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">1. Introduction</h2>
          <p className="text-sm sm:text-base opacity-90">
            Welcome to AICA! These Terms and Conditions outline the rules and
            regulations for the use of our services. By accessing or using our
            platform, you agree to comply with these terms.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">2. Use of Services</h2>
          <p className="text-sm sm:text-base opacity-90">
            You agree to use AICA services only for lawful purposes and in
            compliance with applicable laws and regulations. Any misuse of our
            services may result in suspension or termination of access.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">3. Privacy</h2>
          <p className="text-sm sm:text-base opacity-90">
            Your use of our platform is also governed by our{" "}
            <a href="/privacy" className="underline font-medium">
              Privacy Policy
            </a>
            , which explains how we handle your data.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">4. Refunds</h2>
          <p className="text-sm sm:text-base opacity-90">
            Please refer to our{" "}
            <a href="/refund" className="underline font-medium">
              Refund Policy
            </a>{" "}
            for details about cancellations and refunds.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">5. Limitation of Liability</h2>
          <p className="text-sm sm:text-base opacity-90">
            AICA and its team are not liable for any damages resulting from the
            use or inability to use our services, to the maximum extent
            permitted by law.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">6. Changes to Terms</h2>
          <p className="text-sm sm:text-base opacity-90">
            We may update these terms from time to time. Continued use of our
            services after changes constitutes acceptance of the revised terms.
          </p>
        </section>
      </main>

      {/* Footer Section */}
      <footer className="py-4 bg-black bg-opacity-20 text-center mt-6">
        <p className="text-sm">
          Powered by <span className="font-semibold">AICA</span> | Your Smart Health Assistant
        </p>
        <button
          onClick={() => navigate(-1)}
          className="mt-2 px-4 py-2 bg-white text-teal-600 rounded-lg shadow hover:bg-gray-200 transition"
        >
          Go Back
        </button>
      </footer>
    </div>
  );
};

export default TermsAndConditions;
